import apiClient from './client';

export const fetchDashboard = () => apiClient.get('/dashboard').then((r) => r.data);
